module.exports = __webpack_public_path__ + "img/orion.e6ecc8a2.png";